import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import LoginPage from './pages/LoginPage';
import OverviewPage from './pages/OverviewPage';
import ChatPage from './pages/ChatPage';
import ScenarioEditorPage from './pages/ScenarioEditorPage';
import { getEmail, isEditor } from './utils/auth';
import theme from './theme/theme';

function App() {
  const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
    const email = getEmail();
    if (!isEditor(email)) {
      return <Navigate to="/overview" replace />;
    }
    return children;
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/chat/:patientId" element={<ChatPage />} />
          <Route path="/editor" element={<ProtectedRoute><ScenarioEditorPage /></ProtectedRoute>} />
          <Route path="/editor/:patientId" element={<ProtectedRoute><ScenarioEditorPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
